import { Injectable } from '@angular/core';

import { ClientIntake } from '../../models/client-intake';
import { ClientIntakeField } from '../../models/client-intake-field';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class ClientIntakeFieldService {
  /**
   * URL for client intakes controller
   * @type {String}
   */
  private url = 'client_intake_fields';

  /**
   * Constructor
   * @param {HttpClientService} private httpClient Service for making HTTP requests with different methods
   */
  constructor(private httpClient: HttpClientService) {}

  /**
   * DELETE action for Client Intake Filed resource
   * @param  {number}       id Client Intake Field id
   * @return {Promise<any>}    Response of destroy
   */
  delete(id: number): Promise<any> {
    return this.httpClient.delete(`${this.url}/${id}.json`);
  }

  /**
   * EDIT action for Client Intake Field resource
   * @param  {number}       id Client Intake Field id
   * @return {Promise<any>}    Response of edit
   */
  edit(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}/edit.json`);
  }

  /**
   * Form default options and select options
   * @return {Promise<any>} Response with form options
   */
  formOptions(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { form_options: true });
  }

  /**
   * Get field types from server
   *
   * @param   {string}  fieldTypeClass  Field type class
   *
   * @return  {[type]}                  Response with field types
   */
  getFieldType(fieldTypeClass: string) {
    return this.httpClient.get(`${this.url}/get_field_type.json`, { field_type_class: fieldTypeClass });
  }

  /**
   * INDEX action for Client Intake Field resource
   * @param  {any       =         {}}        params params for filter if any
   * @return {Promise<any>}           Response with client intakes
   */
  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  /**
   * CREATE and UPDATE actions for Client Intake Field resource
   * @param  {ClientIntakeField} phone_number Client Intake Field to be saved
   * @return {Promise<any>} Save response
   */
  save(clientIntakeField: ClientIntakeField): Promise<any> {
    if (clientIntakeField.id) return this.httpClient.put(`${this.url}/${clientIntakeField.id}.json`, { client_intake: clientIntakeField });
    else return this.httpClient.post(`${this.url}.json`, { client_intake_field: clientIntakeField });
  }

  /**
   * Get search select field lists and default options from index action
   * @return {Promise<any>} Response with search options
   */
  searchOptions(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { search_options: true });
  }

  /**
   * SHOW action for Client Intake Field resource
   * @param  {number}       id Client Intake Field id
   * @return {Promise<any>}    Response of edit
   */
  show(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}.json`);
  }
}
